/* eslint-disable no-sequences */
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
author: manilov.ap (https://sketchfab.com/manilov.ap)
license: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
source: https://sketchfab.com/3d-models/cl604-b13966d135794180bcef9f7e6d593c60
title: Cl604
*/

import * as THREE from "three";
import React, { useState, useRef, Suspense } from "react";
import { GLTF } from "three/examples/jsm/loaders/GLTFLoader";
import { proxy, useSnapshot } from "valtio";
import { Canvas } from "@react-three/fiber";
import {
  ContactShadows,
  Environment,
  useGLTF,
  OrbitControls,
} from "@react-three/drei";
type GLTFResult = GLTF & {
  nodes: {
    ["Line24-FACES_1"]: THREE.Mesh;
    ["Object16-FACES_1"]: THREE.Mesh;
    ["Object15-FACES_1"]: THREE.Mesh;
    ["Line23-FACES_1"]: THREE.Mesh;
    ["Object14-FACES_1"]: THREE.Mesh;
    ["Object09-FACES_1"]: THREE.Mesh;
    ["Sphere04-FACES_2"]: THREE.Mesh;
    ["Sphere04-FACES_3"]: THREE.Mesh;
    ["Cylinder02-FACES_1"]: THREE.Mesh;
    ["Object03-FACES_1"]: THREE.Mesh;
    ["Box18-FACES_1"]: THREE.Mesh;
    ["Box17-FACES_1"]: THREE.Mesh;
    ["Line22-FACES_1"]: THREE.Mesh;
    ["Line21-FACES_1"]: THREE.Mesh;
    ["Sphere03-FACES_2"]: THREE.Mesh;
    ["Sphere03-FACES_3"]: THREE.Mesh;
    ["Line20-FACES_1"]: THREE.Mesh;
    ["Line01-FACES_1"]: THREE.Mesh;
    ["Cylinder37-FACES_1"]: THREE.Mesh;
    ["Box16-FACES_1"]: THREE.Mesh;
    ["Box15-FACES_1"]: THREE.Mesh;
    ["Box14-FACES_1"]: THREE.Mesh;
    ["Object13-FACES_2"]: THREE.Mesh;
    ["Object13-FACES_3"]: THREE.Mesh;
    ["lop59-FACES_1"]: THREE.Mesh;
    ["lop58-FACES_1"]: THREE.Mesh;
    ["lop57-FACES_1"]: THREE.Mesh;
    ["lop56-FACES_1"]: THREE.Mesh;
    ["lop55-FACES_1"]: THREE.Mesh;
    ["lop54-FACES_1"]: THREE.Mesh;
    ["lop53-FACES_1"]: THREE.Mesh;
    ["lop52-FACES_1"]: THREE.Mesh;
    ["lop51-FACES_1"]: THREE.Mesh;
    ["lop50-FACES_1"]: THREE.Mesh;
    ["lop49-FACES_1"]: THREE.Mesh;
    ["lop48-FACES_1"]: THREE.Mesh;
    ["lop47-FACES_1"]: THREE.Mesh;
    ["lop46-FACES_1"]: THREE.Mesh;
    ["lop45-FACES_1"]: THREE.Mesh;
    ["lop44-FACES_1"]: THREE.Mesh;
    ["lop43-FACES_1"]: THREE.Mesh;
    ["lop42-FACES_1"]: THREE.Mesh;
    ["lop41-FACES_1"]: THREE.Mesh;
    ["lop40-FACES_1"]: THREE.Mesh;
    ["lop39-FACES_1"]: THREE.Mesh;
    ["lop38-FACES_1"]: THREE.Mesh;
    ["lop37-FACES_1"]: THREE.Mesh;
    ["lop36-FACES_1"]: THREE.Mesh;
    ["lop35-FACES_1"]: THREE.Mesh;
    ["lop34-FACES_1"]: THREE.Mesh;
    ["lop33-FACES_1"]: THREE.Mesh;
    ["lop32-FACES_1"]: THREE.Mesh;
    ["lop31-FACES_1"]: THREE.Mesh;
    ["lop30-FACES_1"]: THREE.Mesh;
    ["lop-FACES_30"]: THREE.Mesh;
    ["lop-FACES_31"]: THREE.Mesh;
    ["lop-FACES_32"]: THREE.Mesh;
    ["lop-FACES_33"]: THREE.Mesh;
    ["lop-FACES_34"]: THREE.Mesh;
    ["lop-FACES_35"]: THREE.Mesh;
    ["lop-FACES_36"]: THREE.Mesh;
    ["lop-FACES_37"]: THREE.Mesh;
    ["lop-FACES_38"]: THREE.Mesh;
    ["lop-FACES_39"]: THREE.Mesh;
    ["lop-FACES_40"]: THREE.Mesh;
    ["lop-FACES_41"]: THREE.Mesh;
    ["lop-FACES_42"]: THREE.Mesh;
    ["lop-FACES_43"]: THREE.Mesh;
    ["lop-FACES_44"]: THREE.Mesh;
    ["lop-FACES_45"]: THREE.Mesh;
    ["lop-FACES_46"]: THREE.Mesh;
    ["lop-FACES_47"]: THREE.Mesh;
    ["lop-FACES_48"]: THREE.Mesh;
    ["lop-FACES_49"]: THREE.Mesh;
    ["lop-FACES_50"]: THREE.Mesh;
    ["lop-FACES_51"]: THREE.Mesh;
    ["lop-FACES_52"]: THREE.Mesh;
    ["lop-FACES_53"]: THREE.Mesh;
    ["lop-FACES_54"]: THREE.Mesh;
    ["lop-FACES_55"]: THREE.Mesh;
    ["lop-FACES_56"]: THREE.Mesh;
    ["lop-FACES_57"]: THREE.Mesh;
    ["lop-FACES_58"]: THREE.Mesh;
    ["lop-FACES_59"]: THREE.Mesh;
    ["Box12-FACES_1"]: THREE.Mesh;
    ["Box11-FACES_1"]: THREE.Mesh;
    ["Box13-FACES_1"]: THREE.Mesh;
    ["Box09-FACES_1"]: THREE.Mesh;
    ["Box08-FACES_1"]: THREE.Mesh;
    ["Box03-FACES_1"]: THREE.Mesh;
    ["Box07-FACES_1"]: THREE.Mesh;
    ["Box06-FACES_1"]: THREE.Mesh;
    ["Box05-FACES_1"]: THREE.Mesh;
    ["Box04-FACES_1"]: THREE.Mesh;
    ["Object08-FACES_1"]: THREE.Mesh;
    ["Object07-FACES_2"]: THREE.Mesh;
    ["Object07-FACES_3"]: THREE.Mesh;
    ["Cylinder24-FACES_1"]: THREE.Mesh;
    ["Cylinder23-FACES_1"]: THREE.Mesh;
    ["Cylinder22-FACES_1"]: THREE.Mesh;
    ["Object06-FACES_1"]: THREE.Mesh;
    ["Torus04-FACES_1"]: THREE.Mesh;
    ["Torus03-FACES_1"]: THREE.Mesh;
    ["Cylinder21-FACES_1"]: THREE.Mesh;
    ["Cylinder20-FACES_1"]: THREE.Mesh;
    ["Box02-FACES_1"]: THREE.Mesh;
    ["Cylinder19-FACES_1"]: THREE.Mesh;
    ["Cylinder18-FACES_2"]: THREE.Mesh;
    ["Cylinder18-FACES_3"]: THREE.Mesh;
    ["Object05-FACES_1"]: THREE.Mesh;
    ["Cylinder17-FACES_2"]: THREE.Mesh;
    ["Cylinder17-FACES_3"]: THREE.Mesh;
    ["Cylinder16-FACES_1"]: THREE.Mesh;
    ["Object04-FACES_1"]: THREE.Mesh;
    ["Cylinder10-FACES_1"]: THREE.Mesh;
    ["Cylinder07-FACES_1"]: THREE.Mesh;
    ["Cylinder08-FACES_1"]: THREE.Mesh;
    ["Object01-FACES_1"]: THREE.Mesh;
    ["Torus02-FACES_1"]: THREE.Mesh;
    ["Torus01-FACES_1"]: THREE.Mesh;
    ["Cylinder09-FACES_1"]: THREE.Mesh;
    ["Box10-FACES_1"]: THREE.Mesh;
    ["Box01-FACES_1"]: THREE.Mesh;
    ["Cylinder12-FACES_1"]: THREE.Mesh;
    ["Cylinder14-FACES_2"]: THREE.Mesh;
    ["Cylinder14-FACES_3"]: THREE.Mesh;
    ["Object02-FACES_1"]: THREE.Mesh;
    ["Cylinder15-FACES_2"]: THREE.Mesh;
    ["Cylinder15-FACES_3"]: THREE.Mesh;
    ["Cylinder13-FACES_1"]: THREE.Mesh;
    ["Sphere02-FACES_1"]: THREE.Mesh;
    ["Sphere01-FACES_1"]: THREE.Mesh;
    ["Cylinder36-FACES_1"]: THREE.Mesh;
    ["Cylinder35-FACES_1"]: THREE.Mesh;
    ["Object12-FACES_2"]: THREE.Mesh;
    ["Object12-FACES_3"]: THREE.Mesh;
    ["Object11-FACES_2"]: THREE.Mesh;
    ["Object11-FACES_3"]: THREE.Mesh;
    ["Object10-FACES_2"]: THREE.Mesh;
    ["Object10-FACES_3"]: THREE.Mesh;
    ["Cylinder34-FACES_1"]: THREE.Mesh;
    ["Cylinder33-FACES_2"]: THREE.Mesh;
    ["Cylinder33-FACES_3"]: THREE.Mesh;
    ["Cylinder32-FACES_1"]: THREE.Mesh;
    ["Cylinder11-FACES_1"]: THREE.Mesh;
    ["Cylinder31-FACES_1"]: THREE.Mesh;
    ["Cylinder30-FACES_2"]: THREE.Mesh;
    ["Cylinder30-FACES_3"]: THREE.Mesh;
    ["Cylinder29-FACES_1"]: THREE.Mesh;
    ["Cylinder28-FACES_1"]: THREE.Mesh;
    ["Cylinder27-FACES_1"]: THREE.Mesh;
    ["Torus06-FACES_1"]: THREE.Mesh;
    ["Cylinder26-FACES_1"]: THREE.Mesh;
    ["Torus05-FACES_1"]: THREE.Mesh;
    ["Cylinder25-FACES_1"]: THREE.Mesh;
    ["Cylinder05-FACES_1"]: THREE.Mesh;
    ["Line18-FACES_1"]: THREE.Mesh;
    ["Cylinder04-FACES_1"]: THREE.Mesh;
    ["Ellipse07-FACES_1"]: THREE.Mesh;
    ["Ellipse06-FACES_1"]: THREE.Mesh;
    ["Ellipse05-FACES_1"]: THREE.Mesh;
    ["Cylinder01-FACES_1"]: THREE.Mesh;
    ["fuzel-FACES_1"]: THREE.Mesh;
  };
  materials: {
    ["Line24-FACES"]: THREE.MeshStandardMaterial;
    ["Sphere04-FACES"]: THREE.MeshStandardMaterial;
    ["Object14-FACES"]: THREE.MeshStandardMaterial;
    ["Line23-FACES"]: THREE.MeshStandardMaterial;
    ["Object09-FACES"]: THREE.MeshStandardMaterial;
    ["Object10-FACES"]: THREE.MeshStandardMaterial;
    ["Cylinder02-FACES"]: THREE.MeshStandardMaterial;
    ["Cylinder04-FACES"]: THREE.MeshStandardMaterial;
    ["Sphere03-FACES"]: THREE.MeshStandardMaterial;
    ["Cylinder25-FACES"]: THREE.MeshStandardMaterial;
    ["lop-FACES"]: THREE.MeshStandardMaterial;
    ["Torus05-FACES"]: THREE.MeshStandardMaterial;
    ["Cylinder05-FACES"]: THREE.MeshStandardMaterial;
    ["Cylinder35-FACES"]: THREE.MeshStandardMaterial;
    ["Line18-FACES"]: THREE.MeshStandardMaterial;
    ["Ellipse06-FACES"]: THREE.MeshStandardMaterial;
    ["Ellipse05-FACES"]: THREE.MeshStandardMaterial;
    ["Cylinder01-FACES"]: THREE.MeshStandardMaterial;
    ["fuzel-FACES"]: THREE.MeshStandardMaterial;
  };
};
const state = proxy({
  current: null,
});
function Model({ ...props }: JSX.IntrinsicElements["group"]) {
  const group = useRef<THREE.Group>();
  const [hover, set] = useState(null);
  console.log(hover);
  const { nodes, materials } = useGLTF("/cl604/scene.gltf") as GLTFResult;
  return (
    <group
      ref={group}
      {...props}
      dispose={null}
      onPointerOver={(e) => (
        //@ts-ignore
        e.stopPropagation(), set(e.object.material.name)
      )}
      onPointerOut={(e) => e.intersections.length === 0 && set(null)}
      onPointerMissed={() => (state.current = null)}
      onPointerDown={(e) => (
        //@ts-ignore
        e.stopPropagation(), set((state.current = e.object.material.name))
      )}
    >
      <group rotation={[-Math.PI / 2, 0, 0]}>
        <group position={[-1.72, -0.83, 0]} rotation={[0, 0, 0.9]}>
          <group rotation={[Math.PI / 2, 0, 0]}>
            <group position={[0, 1.63, 8.24]} rotation={[1.56, 0, -1.57]}>
              <mesh
                geometry={nodes["Line24-FACES_1"].geometry}
                material={materials["Line24-FACES"]}
              />
            </group>
            <group position={[0, 2.95, 4.01]}>
              <mesh
                geometry={nodes["Object16-FACES_1"].geometry}
                material={nodes["Object16-FACES_1"].material}
              />
            </group>
            <group position={[0, 2.95, 4.01]}>
              <mesh
                geometry={nodes["Object15-FACES_1"].geometry}
                material={nodes["Object15-FACES_1"].material}
              />
            </group>
            <group position={[0, 2.95, 4.01]}>
              <mesh
                geometry={nodes["Line23-FACES_1"].geometry}
                material={materials["Line23-FACES"]}
              />
            </group>
            <group position={[0, 2.95, 4.01]}>
              <mesh
                geometry={nodes["Object14-FACES_1"].geometry}
                material={nodes["Object14-FACES_1"].material}
              />
            </group>
            <group position={[0, 2.95, 4.01]}>
              <mesh
                geometry={nodes["Object09-FACES_1"].geometry}
                material={materials["Object09-FACES"]}
              />
            </group>
            <group position={[0, 3.84, -2.07]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes["Sphere04-FACES_2"].geometry}
                material={nodes["Sphere04-FACES_2"].material}
              />
              <mesh
                geometry={nodes["Sphere04-FACES_3"].geometry}
                material={nodes["Sphere04-FACES_3"].material}
              />
            </group>
            <group
              position={[1.02, 2.4, 5.27]}
              rotation={[Math.PI / 2, 0, -Math.PI / 2]}
            >
              <mesh
                geometry={nodes["Cylinder02-FACES_1"].geometry}
                material={materials["Cylinder02-FACES"]}
              />
            </group>
            <group
              position={[0, 1.76, -8.69]}
              rotation={[Math.PI / 2, 0, -Math.PI]}
            >
              <mesh
                geometry={nodes["Object03-FACES_1"].geometry}
                material={nodes["Object03-FACES_1"].material}
              />
            </group>
            <group position={[0, 5.52, 9.88]}>
              <mesh
                geometry={nodes["Box18-FACES_1"].geometry}
                material={nodes["Box18-FACES_1"].material}
              />
            </group>
            <group
              position={[-0.09, 5.52, 9.88]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              scale={[0.77, 1, 0.7]}
            >
              <mesh
                geometry={nodes["Box17-FACES_1"].geometry}
                material={nodes["Box17-FACES_1"].material}
              />
            </group>
            <group position={[0, 2.61, -6.63]}>
              <mesh
                geometry={nodes["Line22-FACES_1"].geometry}
                material={nodes["Line22-FACES_1"].material}
              />
            </group>
            <group
              position={[-1.17, 2.61, -6.63]}
              rotation={[2.43, -1.35, 2.44]}
            >
              <mesh
                geometry={nodes["Line21-FACES_1"].geometry}
                material={nodes["Line21-FACES_1"].material}
              />
            </group>
            <group position={[0, 2.68, 10.85]}>
              <mesh
                geometry={nodes["Sphere03-FACES_2"].geometry}
                material={nodes["Sphere03-FACES_2"].material}
              />
              <mesh
                geometry={nodes["Sphere03-FACES_3"].geometry}
                material={materials["Sphere03-FACES"]}
              />
            </group>
            <group position={[0, 1.93, -6.63]}>
              <mesh
                geometry={nodes["Line20-FACES_1"].geometry}
                material={nodes["Line20-FACES_1"].material}
              />
            </group>
            <group
              position={[-1.17, 1.93, -6.63]}
              rotation={[2.43, -1.35, 2.44]}
            >
              <mesh
                geometry={nodes["Line01-FACES_1"].geometry}
                material={nodes["Line01-FACES_1"].material}
              />
            </group>
            <group position={[0, 3.09, 3.77]}>
              <mesh
                geometry={nodes["Cylinder37-FACES_1"].geometry}
                material={nodes["Cylinder37-FACES_1"].material}
              />
            </group>
            <group position={[0, 1.06, -4.75]}>
              <mesh
                geometry={nodes["Box16-FACES_1"].geometry}
                material={nodes["Box16-FACES_1"].material}
              />
            </group>
            <group position={[0, 3.79, 2.76]}>
              <mesh
                geometry={nodes["Box15-FACES_1"].geometry}
                material={nodes["Box15-FACES_1"].material}
              />
            </group>
            <group position={[0, 3.8, -1.11]}>
              <mesh
                geometry={nodes["Box14-FACES_1"].geometry}
                material={nodes["Box14-FACES_1"].material}
              />
            </group>
            <group position={[-1.64, 1.13, 1.49]}>
              <mesh
                geometry={nodes["Object13-FACES_2"].geometry}
                material={nodes["Object13-FACES_2"].material}
              />
              <mesh
                geometry={nodes["Object13-FACES_3"].geometry}
                material={nodes["Object13-FACES_3"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop59-FACES_1"].geometry}
                material={nodes["lop59-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop58-FACES_1"].geometry}
                material={nodes["lop58-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop57-FACES_1"].geometry}
                material={nodes["lop57-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop56-FACES_1"].geometry}
                material={nodes["lop56-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop55-FACES_1"].geometry}
                material={nodes["lop55-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop54-FACES_1"].geometry}
                material={nodes["lop54-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop53-FACES_1"].geometry}
                material={nodes["lop53-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop52-FACES_1"].geometry}
                material={nodes["lop52-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop51-FACES_1"].geometry}
                material={nodes["lop51-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop50-FACES_1"].geometry}
                material={nodes["lop50-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop49-FACES_1"].geometry}
                material={nodes["lop49-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop48-FACES_1"].geometry}
                material={nodes["lop48-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop47-FACES_1"].geometry}
                material={nodes["lop47-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop46-FACES_1"].geometry}
                material={nodes["lop46-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop45-FACES_1"].geometry}
                material={nodes["lop45-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop44-FACES_1"].geometry}
                material={nodes["lop44-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop43-FACES_1"].geometry}
                material={nodes["lop43-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop42-FACES_1"].geometry}
                material={nodes["lop42-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop41-FACES_1"].geometry}
                material={nodes["lop41-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop40-FACES_1"].geometry}
                material={nodes["lop40-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop39-FACES_1"].geometry}
                material={nodes["lop39-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop38-FACES_1"].geometry}
                material={nodes["lop38-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop37-FACES_1"].geometry}
                material={nodes["lop37-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop36-FACES_1"].geometry}
                material={nodes["lop36-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop35-FACES_1"].geometry}
                material={nodes["lop35-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop34-FACES_1"].geometry}
                material={nodes["lop34-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop33-FACES_1"].geometry}
                material={nodes["lop33-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop32-FACES_1"].geometry}
                material={nodes["lop32-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop31-FACES_1"].geometry}
                material={nodes["lop31-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.13]}>
              <mesh
                geometry={nodes["lop30-FACES_1"].geometry}
                material={nodes["lop30-FACES_1"].material}
              />
            </group>
            <group
              position={[-2.26, 3.38, 3.13]}
              rotation={[Math.PI / 2, 0.21, -Math.PI]}
            >
              <mesh
                geometry={nodes["lop-FACES_30"].geometry}
                material={nodes["lop-FACES_30"].material}
              />
            </group>
            <group
              position={[-2.31, 3.36, 3.13]}
              rotation={[Math.PI / 2, 0.42, -Math.PI]}
            >
              <mesh
                geometry={nodes["lop-FACES_31"].geometry}
                material={nodes["lop-FACES_31"].material}
              />
            </group>
            <group
              position={[-2.36, 3.33, 3.13]}
              rotation={[Math.PI / 2, Math.PI / 5, -Math.PI]}
            >
              <mesh
                geometry={nodes["lop-FACES_32"].geometry}
                material={nodes["lop-FACES_32"].material}
              />
            </group>
            <group
              position={[-2.4, 3.3, 3.13]}
              rotation={[Math.PI / 2, 0.84, Math.PI]}
            >
              <mesh
                geometry={nodes["lop-FACES_33"].geometry}
                material={nodes["lop-FACES_33"].material}
              />
            </group>
            <group
              position={[-2.43, 3.25, 3.13]}
              rotation={[Math.PI / 2, Math.PI / 3, Math.PI]}
            >
              <mesh
                geometry={nodes["lop-FACES_34"].geometry}
                material={nodes["lop-FACES_34"].material}
              />
            </group>
            <group
              position={[-2.45, 3.2, 3.13]}
              rotation={[Math.PI / 2, 1.26, Math.PI]}
            >
              <mesh
                geometry={nodes["lop-FACES_35"].geometry}
                material={nodes["lop-FACES_35"].material}
              />
            </group>
            <group
              position={[-2.47, 3.15, 3.13]}
              rotation={[1.57, 1.47, -3.14]}
            >
              <mesh
                geometry={nodes["lop-FACES_36"].geometry}
                material={nodes["lop-FACES_36"].material}
              />
            </group>
            <group position={[-2.46, 3.09, 3.13]} rotation={[-1.57, 1.47, 0]}>
              <mesh
                geometry={nodes["lop-FACES_37"].geometry}
                material={nodes["lop-FACES_37"].material}
              />
            </group>
            <group
              position={[-2.45, 3.04, 3.13]}
              rotation={[-Math.PI / 2, 1.26, 0]}
            >
              <mesh
                geometry={nodes["lop-FACES_38"].geometry}
                material={nodes["lop-FACES_38"].material}
              />
            </group>
            <group
              position={[-2.43, 2.99, 3.13]}
              rotation={[-Math.PI / 2, Math.PI / 3, 0]}
            >
              <mesh
                geometry={nodes["lop-FACES_39"].geometry}
                material={nodes["lop-FACES_39"].material}
              />
            </group>
            <group
              position={[-2.4, 2.94, 3.13]}
              rotation={[-Math.PI / 2, 0.84, 0]}
            >
              <mesh
                geometry={nodes["lop-FACES_40"].geometry}
                material={nodes["lop-FACES_40"].material}
              />
            </group>
            <group
              position={[-2.36, 2.9, 3.13]}
              rotation={[-1.57, Math.PI / 5, 0]}
            >
              <mesh
                geometry={nodes["lop-FACES_41"].geometry}
                material={nodes["lop-FACES_41"].material}
              />
            </group>
            <group
              position={[-2.31, 2.88, 3.13]}
              rotation={[-Math.PI / 2, 0.42, 0]}
            >
              <mesh
                geometry={nodes["lop-FACES_42"].geometry}
                material={nodes["lop-FACES_42"].material}
              />
            </group>
            <group position={[-2.25, 2.86, 3.13]} rotation={[-1.57, 0.21, 0]}>
              <mesh
                geometry={nodes["lop-FACES_43"].geometry}
                material={nodes["lop-FACES_43"].material}
              />
            </group>
            <group
              position={[-2.2, 2.85, 3.13]}
              rotation={[-Math.PI / 2, 0, 0]}
            >
              <mesh
                geometry={nodes["lop-FACES_44"].geometry}
                material={nodes["lop-FACES_44"].material}
              />
            </group>
            <group position={[-2.14, 2.86, 3.13]} rotation={[-1.57, -0.21, 0]}>
              <mesh
                geometry={nodes["lop-FACES_45"].geometry}
                material={nodes["lop-FACES_45"].material}
              />
            </group>
            <group
              position={[-2.09, 2.88, 3.13]}
              rotation={[-Math.PI / 2, -0.42, 0]}
            >
              <mesh
                geometry={nodes["lop-FACES_46"].geometry}
                material={nodes["lop-FACES_46"].material}
              />
            </group>
            <group
              position={[-2.04, 2.91, 3.13]}
              rotation={[-1.57, -Math.PI / 5, 0]}
            >
              <mesh
                geometry={nodes["lop-FACES_47"].geometry}
                material={nodes["lop-FACES_47"].material}
              />
            </group>
            <group position={[-2, 2.94, 3.13]} rotation={[-1.57, -0.84, 0]}>
              <mesh
                geometry={nodes["lop-FACES_48"].geometry}
                material={nodes["lop-FACES_48"].material}
              />
            </group>
            <group
              position={[-1.97, 2.99, 3.13]}
              rotation={[-Math.PI / 2, -Math.PI / 3, 0]}
            >
              <mesh
                geometry={nodes["lop-FACES_49"].geometry}
                material={nodes["lop-FACES_49"].material}
              />
            </group>
            <group
              position={[-1.95, 3.04, 3.13]}
              rotation={[-Math.PI / 2, -1.26, 0]}
            >
              <mesh
                geometry={nodes["lop-FACES_50"].geometry}
                material={nodes["lop-FACES_50"].material}
              />
            </group>
            <group position={[-1.94, 3.09, 3.13]} rotation={[-1.57, -1.47, 0]}>
              <mesh
                geometry={nodes["lop-FACES_51"].geometry}
                material={nodes["lop-FACES_51"].material}
              />
            </group>
            <group
              position={[-1.94, 3.15, 3.13]}
              rotation={[Math.PI / 2, -1.47, -Math.PI]}
            >
              <mesh
                geometry={nodes["lop-FACES_52"].geometry}
                material={nodes["lop-FACES_52"].material}
              />
            </group>
            <group
              position={[-1.95, 3.2, 3.13]}
              rotation={[1.57, -1.26, Math.PI]}
            >
              <mesh
                geometry={nodes["lop-FACES_53"].geometry}
                material={nodes["lop-FACES_53"].material}
              />
            </group>
            <group
              position={[-1.97, 3.25, 3.13]}
              rotation={[1.57, -Math.PI / 3, Math.PI]}
            >
              <mesh
                geometry={nodes["lop-FACES_54"].geometry}
                material={nodes["lop-FACES_54"].material}
              />
            </group>
            <group position={[-2, 3.3, 3.13]} rotation={[1.57, -0.84, Math.PI]}>
              <mesh
                geometry={nodes["lop-FACES_55"].geometry}
                material={nodes["lop-FACES_55"].material}
              />
            </group>
            <group
              position={[-2.05, 3.34, 3.13]}
              rotation={[Math.PI / 2, -Math.PI / 5, -Math.PI]}
            >
              <mesh
                geometry={nodes["lop-FACES_56"].geometry}
                material={nodes["lop-FACES_56"].material}
              />
            </group>
            <group
              position={[-2.09, 3.36, 3.13]}
              rotation={[Math.PI / 2, -0.42, -Math.PI]}
            >
              <mesh
                geometry={nodes["lop-FACES_57"].geometry}
                material={nodes["lop-FACES_57"].material}
              />
            </group>
            <group
              position={[-2.15, 3.38, 3.13]}
              rotation={[Math.PI / 2, -0.21, -Math.PI]}
            >
              <mesh
                geometry={nodes["lop-FACES_58"].geometry}
                material={nodes["lop-FACES_58"].material}
              />
            </group>
            <group
              position={[-2.2, 3.39, 3.13]}
              rotation={[Math.PI / 2, 0, -Math.PI]}
            >
              <mesh
                geometry={nodes["lop-FACES_59"].geometry}
                material={nodes["lop-FACES_59"].material}
              />
            </group>
            <group position={[-6.61, 1.39, 3.31]}>
              <mesh
                geometry={nodes["Box12-FACES_1"].geometry}
                material={nodes["Box12-FACES_1"].material}
              />
            </group>
            <group position={[-5.52, 1.31, 2.91]}>
              <mesh
                geometry={nodes["Box11-FACES_1"].geometry}
                material={nodes["Box11-FACES_1"].material}
              />
            </group>
            <group position={[0, 3.8, -4.75]}>
              <mesh
                geometry={nodes["Box13-FACES_1"].geometry}
                material={nodes["Box13-FACES_1"].material}
              />
            </group>
            <group position={[-3.24, 1.02, 2.12]}>
              <mesh
                geometry={nodes["Box09-FACES_1"].geometry}
                material={nodes["Box09-FACES_1"].material}
              />
            </group>
            <group position={[-2.08, 0.9, 2.01]}>
              <mesh
                geometry={nodes["Box08-FACES_1"].geometry}
                material={nodes["Box08-FACES_1"].material}
              />
            </group>
            <group
              position={[2.08, 0.9, 2.01]}
              rotation={[1.53, 0, Math.PI / 2]}
              scale={[2.7, 1.96, 2.59]}
            >
              <mesh
                geometry={nodes["Box03-FACES_1"].geometry}
                material={nodes["Box03-FACES_1"].material}
              />
            </group>
            <group
              position={[6.61, 1.39, 3.31]}
              rotation={[1.51, -0.01, 1.55]}
              scale={[1.64, 1.19, 1.2]}
            >
              <mesh
                geometry={nodes["Box07-FACES_1"].geometry}
                material={nodes["Box07-FACES_1"].material}
              />
            </group>
            <group
              position={[5.52, 1.31, 2.91]}
              rotation={[1.51, -0.01, 1.55]}
              scale={[1.91, 1.39, 1.39]}
            >
              <mesh
                geometry={nodes["Box06-FACES_1"].geometry}
                material={nodes["Box06-FACES_1"].material}
              />
            </group>
            <group
              position={[4.51, 1.19, 2.48]}
              rotation={[1.52, -0.01, 1.56]}
              scale={[2.17, 1.57, 1.77]}
            >
              <mesh
                geometry={nodes["Box05-FACES_1"].geometry}
                material={nodes["Box05-FACES_1"].material}
              />
            </group>
            <group
              position={[3.24, 1.02, 2.12]}
              rotation={[1.53, 0, Math.PI / 2]}
              scale={[2.49, 1.8, 2.39]}
            >
              <mesh
                geometry={nodes["Box04-FACES_1"].geometry}
                material={nodes["Box04-FACES_1"].material}
              />
            </group>
            <group position={[1.59, 0.85, 1.23]}>
              <mesh
                geometry={nodes["Object08-FACES_1"].geometry}
                material={nodes["Object08-FACES_1"].material}
              />
            </group>
            <group
              position={[-5, 6.28, 3.45]}
              rotation={[-0.11, 0.02, -1.78]}
              scale={[0.37, 0.43, 0.4]}
            >
              <mesh
                geometry={nodes["Object07-FACES_2"].geometry}
                material={nodes["Object07-FACES_2"].material}
              />
              <mesh
                geometry={nodes["Object07-FACES_3"].geometry}
                material={nodes["Object07-FACES_3"].material}
              />
            </group>
            <group position={[1.56, 0.36, 1.59]}>
              <mesh
                geometry={nodes["Cylinder24-FACES_1"].geometry}
                material={nodes["Cylinder24-FACES_1"].material}
              />
            </group>
            <group position={[1.33, 0.36, 1.59]}>
              <mesh
                geometry={nodes["Cylinder23-FACES_1"].geometry}
                material={nodes["Cylinder23-FACES_1"].material}
              />
            </group>
            <group position={[1.78, 0.36, 1.59]}>
              <mesh
                geometry={nodes["Cylinder22-FACES_1"].geometry}
                material={nodes["Cylinder22-FACES_1"].material}
              />
            </group>
            <group position={[1.57, 0.76, 1.12]}>
              <mesh
                geometry={nodes["Object06-FACES_1"].geometry}
                material={nodes["Object06-FACES_1"].material}
              />
            </group>
            <group position={[1.78, 0.36, 1.59]}>
              <mesh
                geometry={nodes["Torus04-FACES_1"].geometry}
                material={nodes["Torus04-FACES_1"].material}
              />
            </group>
            <group position={[1.33, 0.36, 1.59]}>
              <mesh
                geometry={nodes["Torus03-FACES_1"].geometry}
                material={nodes["Torus03-FACES_1"].material}
              />
            </group>
            <group position={[1.56, 0.36, 1.59]}>
              <mesh
                geometry={nodes["Cylinder21-FACES_1"].geometry}
                material={nodes["Cylinder21-FACES_1"].material}
              />
            </group>
            <group position={[1.56, 0.36, 1.59]}>
              <mesh
                geometry={nodes["Cylinder20-FACES_1"].geometry}
                material={nodes["Cylinder20-FACES_1"].material}
              />
            </group>
            <group
              position={[1.48, 1.21, 1.28]}
              rotation={[-Math.PI / 2, 0, Math.PI / 2]}
              scale={[1, 1.19, 1]}
            >
              <mesh
                geometry={nodes["Box02-FACES_1"].geometry}
                material={nodes["Box02-FACES_1"].material}
              />
            </group>
            <group position={[1.56, 0.36, 1.6]}>
              <mesh
                geometry={nodes["Cylinder19-FACES_1"].geometry}
                material={nodes["Cylinder19-FACES_1"].material}
              />
            </group>
            <group position={[1.56, 0.64, 1.21]}>
              <mesh
                geometry={nodes["Cylinder18-FACES_2"].geometry}
                material={nodes["Cylinder18-FACES_2"].material}
              />
              <mesh
                geometry={nodes["Cylinder18-FACES_3"].geometry}
                material={nodes["Cylinder18-FACES_3"].material}
              />
            </group>
            <group position={[1.56, 0.76, 1.13]}>
              <mesh
                geometry={nodes["Object05-FACES_1"].geometry}
                material={nodes["Object05-FACES_1"].material}
              />
            </group>
            <group position={[1.56, 0.57, 1.51]}>
              <mesh
                geometry={nodes["Cylinder17-FACES_2"].geometry}
                material={nodes["Cylinder17-FACES_2"].material}
              />
              <mesh
                geometry={nodes["Cylinder17-FACES_3"].geometry}
                material={nodes["Cylinder17-FACES_3"].material}
              />
            </group>
            <group position={[1.56, 0.41, 1.21]}>
              <mesh
                geometry={nodes["Cylinder16-FACES_1"].geometry}
                material={nodes["Cylinder16-FACES_1"].material}
              />
            </group>
            <group
              position={[-1.69, 0.81, 1.23]}
              rotation={[-Math.PI / 2, -0.32, -Math.PI / 2]}
              scale={[0.06, 1.39, 0.06]}
            >
              <mesh
                geometry={nodes["Object04-FACES_1"].geometry}
                material={nodes["Object04-FACES_1"].material}
              />
            </group>
            <group
              position={[-1.39, 0.36, 1.59]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              scale={[0.42, 2.3, 0.42]}
            >
              <mesh
                geometry={nodes["Cylinder10-FACES_1"].geometry}
                material={nodes["Cylinder10-FACES_1"].material}
              />
            </group>
            <group
              position={[-1.23, 0.36, 1.59]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              scale={[1, 1.38, 1]}
            >
              <mesh
                geometry={nodes["Cylinder07-FACES_1"].geometry}
                material={nodes["Cylinder07-FACES_1"].material}
              />
            </group>
            <group
              position={[-1.68, 0.36, 1.59]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              scale={[1, 1.38, 1]}
            >
              <mesh
                geometry={nodes["Cylinder08-FACES_1"].geometry}
                material={nodes["Cylinder08-FACES_1"].material}
              />
            </group>
            <group
              position={[-1.43, 0.84, 1.12]}
              rotation={[Math.PI / 2, 0.51, Math.PI / 2]}
              scale={[0.1, 2.3, 0.1]}
            >
              <mesh
                geometry={nodes["Object01-FACES_1"].geometry}
                material={nodes["Object01-FACES_1"].material}
              />
            </group>
            <group
              position={[-1.78, 0.36, 1.59]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
            >
              <mesh
                geometry={nodes["Torus02-FACES_1"].geometry}
                material={nodes["Torus02-FACES_1"].material}
              />
            </group>
            <group
              position={[-1.33, 0.36, 1.59]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
            >
              <mesh
                geometry={nodes["Torus01-FACES_1"].geometry}
                material={nodes["Torus01-FACES_1"].material}
              />
            </group>
            <group
              position={[-1.39, 0.36, 1.59]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              scale={[0.42, 2.3, 0.42]}
            >
              <mesh
                geometry={nodes["Cylinder09-FACES_1"].geometry}
                material={nodes["Cylinder09-FACES_1"].material}
              />
            </group>
            <group position={[-4.51, 1.19, 2.48]}>
              <mesh
                geometry={nodes["Box10-FACES_1"].geometry}
                material={nodes["Box10-FACES_1"].material}
              />
            </group>
            <group
              position={[-1.48, 1.21, 1.28]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              scale={[1, 1.19, 1]}
            >
              <mesh
                geometry={nodes["Box01-FACES_1"].geometry}
                material={nodes["Box01-FACES_1"].material}
              />
            </group>
            <group
              position={[-1.56, 0.4, 1.36]}
              rotation={[1.73, 0, 0]}
              scale={[0.31, 0.94, 0.31]}
            >
              <mesh
                geometry={nodes["Cylinder12-FACES_1"].geometry}
                material={nodes["Cylinder12-FACES_1"].material}
              />
            </group>
            <group
              position={[-1.56, 0.81, 1.21]}
              rotation={[-Math.PI, 1.57, 0]}
              scale={[0.42, 2.3, 0.42]}
            >
              <mesh
                geometry={nodes["Cylinder14-FACES_2"].geometry}
                material={nodes["Cylinder14-FACES_2"].material}
              />
              <mesh
                geometry={nodes["Cylinder14-FACES_3"].geometry}
                material={nodes["Cylinder14-FACES_3"].material}
              />
            </group>
            <group
              position={[-1.56, 0.76, 1.02]}
              rotation={[1.58, Math.PI / 2, 0]}
              scale={[0.22, 1.6, 0.22]}
            >
              <mesh
                geometry={nodes["Object02-FACES_1"].geometry}
                material={nodes["Object02-FACES_1"].material}
              />
            </group>
            <group
              position={[-1.56, 0.69, 1.49]}
              rotation={[2.92, 1.57, 0]}
              scale={[0.29, 1.59, 0.29]}
            >
              <mesh
                geometry={nodes["Cylinder15-FACES_2"].geometry}
                material={nodes["Cylinder15-FACES_2"].material}
              />
              <mesh
                geometry={nodes["Cylinder15-FACES_3"].geometry}
                material={nodes["Cylinder15-FACES_3"].material}
              />
            </group>
            <group
              position={[-1.11, 0.41, 1.21]}
              rotation={[1.53, -0.02, 1.53]}
              scale={[0.15, 3.87, 0.15]}
            >
              <mesh
                geometry={nodes["Cylinder13-FACES_1"].geometry}
                material={nodes["Cylinder13-FACES_1"].material}
              />
            </group>
            <group position={[2.2, 3.12, 3.14]}>
              <mesh
                geometry={nodes["Sphere02-FACES_1"].geometry}
                material={nodes["Sphere02-FACES_1"].material}
              />
            </group>
            <group
              position={[-2.2, 3.12, 3.14]}
              rotation={[Math.PI / 2, 0, -Math.PI]}
              scale={[1.43, 1, 1.43]}
            >
              <mesh
                geometry={nodes["Sphere01-FACES_1"].geometry}
                material={nodes["Sphere01-FACES_1"].material}
              />
            </group>
            <group position={[0, 2.84, 4.65]}>
              <mesh
                geometry={nodes["Cylinder36-FACES_1"].geometry}
                material={nodes["Cylinder36-FACES_1"].material}
              />
            </group>
            <group position={[0, 3.12, 2.67]}>
              <mesh
                geometry={nodes["Cylinder35-FACES_1"].geometry}
                material={materials["Cylinder35-FACES"]}
              />
            </group>
            <group position={[0, 1.3, -7.6]}>
              <mesh
                geometry={nodes["Object12-FACES_2"].geometry}
                material={nodes["Object12-FACES_2"].material}
              />
              <mesh
                geometry={nodes["Object12-FACES_3"].geometry}
                material={nodes["Object12-FACES_3"].material}
              />
            </group>
            <group
              position={[-0.54, 1.38, -8.77]}
              rotation={[-0.38, -1.26, 0.9]}
            >
              <mesh
                geometry={nodes["Object11-FACES_2"].geometry}
                material={nodes["Object11-FACES_2"].material}
              />
              <mesh
                geometry={nodes["Object11-FACES_3"].geometry}
                material={nodes["Object11-FACES_3"].material}
              />
            </group>
            <group position={[0, -1.21, -5.92]} rotation={[-0.33, 0, -Math.PI]}>
              <mesh
                geometry={nodes["Object10-FACES_2"].geometry}
                material={nodes["Object10-FACES_2"].material}
              />
              <mesh
                geometry={nodes["Object10-FACES_3"].geometry}
                material={nodes["Object10-FACES_3"].material}
              />
            </group>
            <group
              position={[0, 0.3, -6.45]}
              rotation={[-2.05, 0, 0]}
              scale={[0.13, 0.39, 0.13]}
            >
              <mesh
                geometry={nodes["Cylinder34-FACES_1"].geometry}
                material={nodes["Cylinder34-FACES_1"].material}
              />
            </group>
            <group
              position={[0, 0.52, -6.35]}
              rotation={[2.41, 1.57, 0]}
              scale={[0.15, 0.81, 0.15]}
            >
              <mesh
                geometry={nodes["Cylinder33-FACES_2"].geometry}
                material={nodes["Cylinder33-FACES_2"].material}
              />
              <mesh
                geometry={nodes["Cylinder33-FACES_3"].geometry}
                material={nodes["Cylinder33-FACES_3"].material}
              />
            </group>
            <group
              position={[0.3, 0.49, -6.65]}
              rotation={[1.53, -0.02, 1.53]}
              scale={[0.1, 2.61, 0.1]}
            >
              <mesh
                geometry={nodes["Cylinder32-FACES_1"].geometry}
                material={nodes["Cylinder32-FACES_1"].material}
              />
            </group>
            <group
              position={[-1.49, 0.36, 1.59]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              scale={[0.68, 0.94, 0.68]}
            >
              <mesh
                geometry={nodes["Cylinder11-FACES_1"].geometry}
                material={nodes["Cylinder11-FACES_1"].material}
              />
            </group>
            <group
              position={[0, 0.4, -6.6]}
              rotation={[2.7, 0, 0]}
              scale={[0.21, 0.63, 0.21]}
            >
              <mesh
                geometry={nodes["Cylinder31-FACES_1"].geometry}
                material={nodes["Cylinder31-FACES_1"].material}
              />
            </group>
            <group
              position={[0, 0.76, -6.64]}
              rotation={[-Math.PI, 1.57, 0]}
              scale={[0.28, 1.55, 0.28]}
            >
              <mesh
                geometry={nodes["Cylinder30-FACES_2"].geometry}
                material={nodes["Cylinder30-FACES_2"].material}
              />
              <mesh
                geometry={nodes["Cylinder30-FACES_3"].geometry}
                material={nodes["Cylinder30-FACES_3"].material}
              />
            </group>
            <group
              position={[0.05, 0.26, -6.54]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              scale={[0.46, 0.63, 0.46]}
            >
              <mesh
                geometry={nodes["Cylinder29-FACES_1"].geometry}
                material={nodes["Cylinder29-FACES_1"].material}
              />
            </group>
            <group
              position={[0.11, 0.26, -6.54]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              scale={[0.28, 1.55, 0.28]}
            >
              <mesh
                geometry={nodes["Cylinder28-FACES_1"].geometry}
                material={nodes["Cylinder28-FACES_1"].material}
              />
            </group>
            <group
              position={[0.11, 0.26, -6.54]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              scale={[0.28, 1.55, 0.28]}
            >
              <mesh
                geometry={nodes["Cylinder27-FACES_1"].geometry}
                material={nodes["Cylinder27-FACES_1"].material}
              />
            </group>
            <group
              position={[0.15, 0.26, -6.54]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              scale={0.67}
            >
              <mesh
                geometry={nodes["Torus06-FACES_1"].geometry}
                material={nodes["Torus06-FACES_1"].material}
              />
            </group>
            <group
              position={[0.22, 0.26, -6.54]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              scale={[0.67, 0.93, 0.67]}
            >
              <mesh
                geometry={nodes["Cylinder26-FACES_1"].geometry}
                material={nodes["Cylinder26-FACES_1"].material}
              />
            </group>
            <group
              position={[-0.15, 0.26, -6.54]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              scale={0.67}
            >
              <mesh
                geometry={nodes["Torus05-FACES_1"].geometry}
                material={nodes["Torus05-FACES_1"].material}
              />
            </group>
            <group
              position={[-0.08, 0.26, -6.54]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              scale={[0.67, 0.93, 0.67]}
            >
              <mesh
                geometry={nodes["Cylinder25-FACES_1"].geometry}
                material={nodes["Cylinder25-FACES_1"].material}
              />
            </group>
            <group position={[0, 2.84, 4.65]}>
              <mesh
                geometry={nodes["Cylinder05-FACES_1"].geometry}
                material={nodes["Cylinder05-FACES_1"].material}
              />
            </group>
            <group position={[0, 2.95, 4.01]}>
              <mesh
                geometry={nodes["Line18-FACES_1"].geometry}
                material={materials["Line18-FACES"]}
              />
            </group>
            <group position={[0, 3.09, 3.77]}>
              <mesh
                geometry={nodes["Cylinder04-FACES_1"].geometry}
                material={nodes["Cylinder04-FACES_1"].material}
              />
            </group>
            <group position={[0, 6.13, 11.81]}>
              <mesh
                geometry={nodes["Ellipse07-FACES_1"].geometry}
                material={nodes["Ellipse07-FACES_1"].material}
              />
            </group>
            <group
              position={[-1.44, 6.13, 11.81]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              scale={0.45}
            >
              <mesh
                geometry={nodes["Ellipse06-FACES_1"].geometry}
                material={nodes["Ellipse06-FACES_1"].material}
              />
            </group>
            <group
              position={[0, 6.21, 10.48]}
              rotation={[0, -1.57, 0]}
              scale={[0.79, 0.79, 0.79]}
            >
              <mesh
                geometry={nodes["Ellipse05-FACES_1"].geometry}
                material={materials["Ellipse05-FACES"]}
              />
            </group>
            <group position={[-2.2, 3.12, 2.67]} rotation={[Math.PI / 2, 0, 0]}>
              <mesh
                geometry={nodes["Cylinder01-FACES_1"].geometry}
                material={materials["Cylinder01-FACES"]}
              />
            </group>
            <group
              position={[0, 1.76, -8.69]}
              rotation={[Math.PI / 2, 0, -Math.PI]}
            >
              <mesh
                geometry={nodes["fuzel-FACES_1"].geometry}
                material={materials["fuzel-FACES"]}
              />
            </group>
          </group>
        </group>
      </group>
    </group>
  );
}
function Definition() {
  const snap = useSnapshot(state);
  if (
    snap.current === "lop-FACES " ||
    snap.current === "Cylinder01-FACES" ||
    snap.current === "Cylinder04-FACES" ||
    snap.current === "Cylinder35-FACES"
  ) {
    return (
      <div className="space-y-4 flex flex-col items-center">
        <h1 className="text-2xl font-bold">Turbofan engines</h1>
        <p className="text-justify px-10 md:text-xl text-lg font-semibold">
          The gas turbine engine has almost completely replaced the
          reciprocating engine for aircraft propulsion. Jet engines derive
          thrust by ejecting the products of combustion in a jet at high speed.
          A turbine engine that passes all the air through the combustion
          chamber is called a turbojet
        </p>
      </div>
    );
  } else if (
    snap.current === "Line18-FACES" ||
    snap.current === "Line23-FACES"
  ) {
    return (
      <div className="space-y-4 flex flex-col items-center">
        <h1 className="text-2xl font-bold">Wingsman</h1>
        <p className="text-justify px-10 md:text-xl text-lg font-semibold">
          An aircraft’s wings are critical to flight through the production of
          lift, but they have many parts of the wing to control this lift amount
          and direction.
        </p>
      </div>
    );
  } else if (snap.current === "fuzel-FACES") {
    return (
      <div className="space-y-6 flex flex-col items-center">
        <h1 className="font-bold font-sans "> Fuselarg </h1>
        <p className="font-semibold font-mono px-10 text-justify md:text-xl text-lg">
          The plane’s body, or fuselage, holds the aircraft together, with
          pilots sitting at the front of the fuselage, passengers and cargo in
          the back.
        </p>
      </div>
    );
  } else if (
    snap.current === "Cylinder25-FACES" ||
    snap.current === "Torus05-FACES"
  ) {
    return (
      <div className="flex space-y-4 flex-col items-center">
        <h1 className="font-bold  font-serif"> Wheels </h1>
        <p className="font-semibold font-mono px-10 text-justify md:text-xl text-lg">
          Landing gear is located under the belly of the plane consisting of a
          wheel and strut to soften impact with the ground and may be
          retractable into the fuselage. Tricycle type wheels are common for
          general aviation with one wheel at the front and two behind or the
          reverse for tailwheels with two wheels at the front of the plane and
          one under the tail.
        </p>
      </div>
    );
  } else if (snap.current === "Ellipse06-FACES") {
    return (
      <div className="flex space-y-4 flex-col items-center">
        <h1 className="font-bold  font-serif">Horizontal Stabliser</h1>
        <p className="font-semibold font-mono px-10 text-justify md:text-xl text-lg">
          he horizontal stabilizer keeps the airplane’s nose from moving up and
          down (pitch). The hinged part on the horizontal stabilizer is the
          elevator and is one of the primary flight controls. When the pilot in
          the cockpit pulls back on the yoke, the elevators go up, causing more
          force to push down on the tail, lifting up the nose of the aircraft.
          Raising the nose changes the angle of attack on the wings, increasing
          lift.
        </p>
      </div>
    );
  } else if (snap.current === "Ellipse05-FACES") {
    return (
      <div className="space-y-4 flex flex-col items-center">
        <h1 className="font-bold  font-serif"> Tail </h1>
        <p className="font-semibold font-mono px-10 text-justify md:text-xl text-lg">
          An aircraft’s tail is mainly used for stability, as well as creating
          lift in combination with the wings. It’s comprised of several parts.
        </p>
      </div>
    );
  } else {
    return (
      <div className="text-2xl font-semibold font-mono px-10 text-justify">
        Click on different parts of plane
      </div>
    );
  }
}
export default function cl604() {
  return (
    <div className="flex md:flex-row w-full flex-col bg-blue-200 mx-auto ">
      <div className="w-full  h-screen md:px-4 px-8 outline-none cursor-pointer   lg:block ">
        <Canvas shadows dpr={[1, 2]} camera={{ position: [0, 0, 4], fov: 50 }}>
          <ambientLight intensity={0.7} />
          <spotLight
            intensity={0.5}
            angle={0.1}
            penumbra={1}
            position={[10, 15, 10]}
            castShadow
          />
          <Suspense fallback={null}>
            <Model scale={0.14} />
            <Environment preset="city" />
            <ContactShadows
              rotation-x={Math.PI / 2}
              position={[0, -0.8, 0]}
              opacity={0.25}
              width={10}
              height={10}
              blur={1.5}
              far={0.8}
            />
          </Suspense>
          <OrbitControls />
        </Canvas>
      </div>
      <div className="w-full flex  justify-center text-justify px-10  md:px-4 my-auto  md:text-2xl text-base font-mono">
        {" "}
        <Definition />{" "}
      </div>
    </div>
  );
}
